import {appSlice} from "./lib/app";
import {configureStore} from '@reduxjs/toolkit';


export const appStore = configureStore({
  reducer: {
    app: appSlice.reducer,
  },
});

// @ts-ignore
export type RootState = ReturnType<typeof appStore.getState>
export type AppDispatch = typeof appStore.dispatch;
